@if (showPreviousImageSelector()) {
	<app-previous-image-selector
		table="content_text"
		column="image_uri"
		(onSelectImageUrl)="selectImageUri($event)"
		(onClose)="showPreviousImageSelector.set(false)"
	></app-previous-image-selector>
}

<form [formGroup]="form" (ngSubmit)="submit()">
	<app-form-title [editMode]="content() !== undefined" model="Content"></app-form-title>

	<app-dropdown-field
		[fg]="form"
		formGroupOrControlName="contentType"
		label="Content Type"
		[options]="options"
	></app-dropdown-field>

	<app-name-field [fg]="form" formGroupOrControlName="name"></app-name-field>

	<app-html-description-field
		[fg]="form"
		formGroupOrControlName="descriptionHtml"
		label="Description"
	></app-html-description-field>

	<app-text-field [fg]="form" formGroupOrControlName="descriptionShort" label="Short Description"></app-text-field>

	<app-scoring-method-field
		[fg]="form"
		formGroupOrControlName="scoringMethod"
		label="Scoring Method"
	></app-scoring-method-field>

	@if (rubric()) {
		<app-rubric-level-dropdown-field
			[rubric]="rubric()"
			[fg]="form"
			formGroupOrControlName="rubricLevelUuid"
			label="Rubric Level"
		></app-rubric-level-dropdown-field>
	}

	@if (rubric()) {
		<app-skill-code-dropdown-field
			[fg]="form"
			formGroupOrControlName="skillCode"
			label="Skill"
		></app-skill-code-dropdown-field>
	}

	<app-checkbox-field [fg]="form" formGroupOrControlName="isFeatured" label="Feature Mode"></app-checkbox-field>

	<p>
		("Featured Mode" should be used when there's only one piece of content that should be mostly full screen like a
		video or hubs experience.)
	</p>

	<app-text-field
		[fg]="form"
		formGroupOrControlName="imageUri"
		label="Image URI"
		[enableUpload]="true"
		accept="image/*"
		[multiple]="false"
		[directory]="false"
		[enablePrevious]="true"
		(showPrevious)="showPreviousImageSelector.set(true)"
	></app-text-field>

	<app-text-field
		[fg]="form"
		formGroupOrControlName="contentUri"
		label="Content URI"
		[enableUpload]="true"
		accept=".zip,.h5p,application/zip,application/x-zip-compressed,application/h5p"
		[multiple]="false"
		[directory]="false"
	></app-text-field>

	<div
		class="content-uri-uuid-status"
		[ngClass]="[form.get('contentUri')?.value?.indexOf(' ') >= 0 ? 'red' : '']"
		nz-tooltip="Turns red if there's a space in the field"
	>
		{{ form.get('contentUri')?.value ? form.get('contentUri')?.value?.split('?')[1] : '' }}
	</div>

	<app-textarea-field [fg]="form" formGroupOrControlName="dataJson" label="Data JSON"></app-textarea-field>

	<div class="buttons">
		<button nz-button nzType="primary" type="submit" [disabled]="form.invalid">Submit</button>
		<button nz-button type="button" (click)="clear()">Clear</button>
	</div>
</form>
